import { render, staticRenderFns } from "./FaqBlock.vue?vue&type=template&id=75d47859&scoped=true&"
import script from "./FaqBlock.vue?vue&type=script&lang=js&"
export * from "./FaqBlock.vue?vue&type=script&lang=js&"
import style0 from "./FaqBlock.vue?vue&type=style&index=0&id=75d47859&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d47859",
  null
  
)

export default component.exports